/** @format */

import React, { memo } from 'react';

import styled from 'styled-components';

import { TTranslation, useAppTranslation } from '../../i18n/declarations';

// #region ::: COMPONENTS

const LinkText = styled.p`
  font-weight: 800;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.joivy.black};
  span {
    color: ${({ theme }) => theme.colors.joivy.pink};
    text-decoration: underline;
  }

  @media (max-width: 768px) {
  }
`;

// #endregion

interface Props {
  url: string;
  onClick?: () => void;
}

export const NeighborhoodLink = memo(({ url, onClick }: Props) => {
  const { t } = useAppTranslation();
  const { intl } = useAppTranslation();
  const { locale } = intl;

  return (
    <a
      onClick={onClick}
      style={{ textUnderlineOffset: '3px', textDecoration: 'none' }}
      href={'/' + locale + url}
      target="_blank"
    >
      <LinkText dangerouslySetInnerHTML={{ __html: t('pdp.discover_district' as TTranslation) }} />
    </a>
  );
});
